var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.textColour, 'button-submit'],attrs:{"id":"mc-embedded-subscribe"}},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('IconArrow',{attrs:{"colour":_vm.arrowColour,"direction":'next'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }